module.exports = __webpack_public_path__ + "img/add-card-referall-program.737fae60.svg";